import { storage } from '@/utils/storage';

const STORAGE_KEY = 'selected_gifts';

export function buildBasketHash(basket) {
  if (!Array.isArray(basket) || basket.length === 0) return '';
  return basket
    .map((item) => `${item.select_type.id}:${item.select_count}`)
    .sort()
    .join('|');
}

export function readGiftSelection() {
  try {
    const raw = storage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.basketHash !== 'string' || !Array.isArray(parsed.selectedGifts)) {
      return null;
    }
    return parsed;
  } catch (e) {
    return null;
  }
}

export function writeGiftSelection(basketHash, selectedGifts) {
  try {
    storage.setItem(STORAGE_KEY, JSON.stringify({ basketHash, selectedGifts }));
  } catch (e) {
    /* noop */
  }
}

export function clearGiftSelection() {
  try {
    storage.removeItem(STORAGE_KEY);
  } catch (e) {
    /* noop */
  }
}
